import React from 'react';

import { onboardingElementIds } from 'services/onboarding/constants';
import { TeamSection } from 'services/userOrganization/Components/TeamSection';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { HomeLayout } from 'modules/home/components/HomeLayout';
import { useOrganization } from 'core/stores/hooks/useOrganization';

export const HomeTeamPageTab: React.FC = () => {
  const { isAdmin } = useIsAdmin();
  const organization = useOrganization();

  return (
    <HomeLayout>
      <div id={onboardingElementIds.homePageContainer}>
        {isAdmin && (
          <TeamSection title="Account teams" organizationId={organization.id} />
        )}
      </div>
    </HomeLayout>
  );
};
